// src/services/queries/dashboards/currentDashboardQueries.ts

import { API_BASE_URL } from "@/services/";
import type {
  CurrentValuesResponse,
  WindowsResponse,
} from "@/types/dashboards/dashboardCurrent";
import { TIME_WINDOWS } from "@/constants/metrics";

export const DASHBOARD_WINDOWS = TIME_WINDOWS.API;

export async function fetchDashboardCurrent(params: {
  categoryId: number;
  signal?: AbortSignal;
}): Promise<CurrentValuesResponse> {
  const url = `${API_BASE_URL}/dashboard/current?category_id=${params.categoryId}`;
  const init: RequestInit = params.signal ? { signal: params.signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function fetchDashboardCurrentRatios(params: {
  categoryId: number;
  ratioKeysCsv?: string; // already mapped and csv'd
  sortBy?: string;
  descending?: boolean;
  limit?: number;
  signal?: AbortSignal;
}): Promise<CurrentValuesResponse> {
  const sp = new URLSearchParams();
  sp.set("category_id", String(params.categoryId));
  if (params.ratioKeysCsv) sp.set("ratio_keys", params.ratioKeysCsv);
  if (params.sortBy) sp.set("sort_by", params.sortBy);
  if (params.descending !== undefined) sp.set("descending", String(params.descending));
  if (params.limit !== undefined) sp.set("limit", String(params.limit));
  const url = `${API_BASE_URL}/dashboard/current/ratios?${sp.toString()}`;
  const init: RequestInit = params.signal ? { signal: params.signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function fetchDashboardCurrentRollups(params: {
  categoryId: number;
  metricKeysCsv?: string; // already mapped and csv'd
  windowsCsv?: string;
  signal?: AbortSignal;
}): Promise<WindowsResponse> {
  const sp = new URLSearchParams();
  sp.set("category_id", String(params.categoryId));
  if (params.metricKeysCsv) sp.set("metric_keys", params.metricKeysCsv);
  sp.set("windows", params.windowsCsv ?? DASHBOARD_WINDOWS.join(","));
  const url = `${API_BASE_URL}/dashboard/current/rollups?${sp.toString()}`;
  const init: RequestInit = params.signal ? { signal: params.signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function fetchDashboardCurrentChanges(params: {
  categoryId: number;
  metricKeysCsv?: string; // already mapped and csv'd
  windowsCsv?: string;
  signal?: AbortSignal;
}): Promise<WindowsResponse> {
  const sp = new URLSearchParams();
  sp.set("category_id", String(params.categoryId));
  if (params.metricKeysCsv) sp.set("metric_keys", params.metricKeysCsv);
  sp.set("windows", params.windowsCsv ?? [...DASHBOARD_WINDOWS].join(","));
  const url = `${API_BASE_URL}/dashboard/current/changes?${sp.toString()}`;
  const init: RequestInit = params.signal ? { signal: params.signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}


